

import templateUserLikedItemListPage from '@/app-template/lib/pages/UserLikedItemListPage.vue';

export default {
  name: "UserLikedItemListPage",
  components: { templateUserLikedItemListPage },
};
